import React from 'react';
import { DropletIcon, MinusIcon, PlusIcon } from 'lucide-react';
import { CONFIG } from '../data/config';
import { plata } from '../utils/format';
import { Paso } from './Paso';
import type { Carrito } from '../utils/pedido';
interface Props {
  carrito: Carrito;
  total: number;
  onCambio: (id: string, delta: number) => void;
}
export function PasoProductos({
  carrito,
  total,
  onCambio
}: Props) {
  const minimo = CONFIG.pedidoMinimo;
  const falta = minimo - total;
  let categoriaAnterior: string | null = null;
  return <Paso num="02" titulo="¿Qué te dejamos?" data-id="element-78" data-mp="2ty0af7qoak2z">
      <div data-id="element-79" data-mp="37q6rcw1ngv3h">
        {CONFIG.productos.map(p => {
        const nuevaCategoria = p.categoria !== categoriaAnterior;
        const sellos = nuevaCategoria ? CONFIG.categoriaSellos[p.categoria] : undefined;
        if (nuevaCategoria) categoriaAnterior = p.categoria;
        const cant = carrito[p.id] ?? 0;
        return <React.Fragment key={p.id} data-id="element-80" data-mp="3cq2ms6wa7e7f">
              {nuevaCategoria && <h3 className="mb-1 mt-5 text-[11.5px] font-bold uppercase tracking-[0.075em] text-accent first:mt-0.5" data-id="element-81" data-mp="18p1axdddrl7w">
                  {p.categoria}
                </h3>}
              {sellos && <ul className="mb-2.5 flex list-none flex-wrap gap-1.5 p-0" data-id="element-82" data-mp="1hp6gdhz0k9jf">
                  {sellos.map(s => <li key={s} className="rounded-full bg-accent-soft px-2.5 py-1 text-[11.5px] font-semibold text-accent" data-id="element-83" data-mp="1mpc1sgeowzt2">
                      {s}
                    </li>)}
                </ul>}

              <div className={`flex items-center gap-3 py-3.5 ${nuevaCategoria ? 'border-t-0 pt-0.5' : 'border-t border-line'}`} data-id="element-84" data-mp="21eqbjpm6hj8z">
                {p.imagen ? <img src={p.imagen} alt="" loading="lazy" className="shrink-0 rounded-[10px] border border-line bg-white object-cover" style={{
              width: 52,
              height: 52
            }} data-id="element-85" data-mp="2ac0qbky7fqin" /> : <div className="grid shrink-0 place-items-center rounded-[10px] bg-accent-soft text-accent" style={{
              width: 52,
              height: 52
            }} aria-hidden="true" data-id="element-86" data-mp="aa17vpbyq37i">
                    <DropletIcon className="h-[22px] w-[22px]" fill="currentColor" strokeWidth={0} data-id="element-87" data-mp="y0f1hka74a47" />
                  </div>}

                <div className="min-w-0 flex-1" data-id="element-88" data-mp="u1xquqrkghi1">
                  <p className={`text-[15px] font-semibold leading-snug ${cant > 0 ? 'text-accent' : ''}`} data-id="element-89" data-mp="17zw0xjyutrrq">
                    {p.nombre}
                  </p>
                  {p.detalle && <p className="mt-px text-[12.5px] leading-snug text-ink-faint" data-id="element-90" data-mp="39qr0mmw6mb3q">{p.detalle}</p>}
                  <p className="mt-0.5 font-mono text-[13.5px] font-semibold tnum text-ink-soft" data-id="element-91" data-mp="34s600md0pper">{plata(p.precio)}</p>
                </div>

                <div className="flex shrink-0 items-center gap-px rounded-full border border-line bg-surface-2 p-[3px]" data-id="element-92" data-mp="1kb6m6y0m9f6a">
                  <button type="button" onClick={() => onCambio(p.id, -1)} disabled={cant === 0} aria-label={`Sacar uno de ${p.nombre}`} className="grid h-[31px] w-[31px] place-items-center rounded-full text-ink-soft transition-colors duration-150 ease-soft hover:bg-accent-soft hover:text-accent disabled:pointer-events-none disabled:opacity-30" data-id="element-93" data-mp="1p86px29zu5u8">
                    <MinusIcon className="h-4 w-4" strokeWidth={2.4} data-id="element-94" data-mp="rm9etpxy12sb" />
                  </button>
                  <span className="min-w-[24px] text-center font-mono text-[15px] font-bold tnum" data-id="element-95" data-mp="wlcaijs19wnm">{cant}</span>
                  <button type="button" onClick={() => onCambio(p.id, 1)} aria-label={`Agregar uno de ${p.nombre}`} className="grid h-[31px] w-[31px] place-items-center rounded-full text-ink-soft transition-colors duration-150 ease-soft hover:bg-accent-soft hover:text-accent" data-id="element-96" data-mp="2m0ipdzdvqp20">
                    <PlusIcon className="h-4 w-4" strokeWidth={2.4} data-id="element-97" data-mp="hul6npqktkw8" />
                  </button>
                </div>
              </div>
            </React.Fragment>;
      })}
      </div>

      {minimo > 0 && <p className={`mt-3.5 border-t border-dashed border-line pt-3 text-[13px] ${total > 0 && falta > 0 ? 'font-semibold text-warn' : 'text-ink-faint'}`} data-id="element-98" data-mp="7y01n4ek49se">
          {total === 0 ? `Pedido mínimo: ${plata(minimo)}.` : falta > 0 ? `Te faltan ${plata(falta)} para llegar al mínimo.` : 'Llegaste al mínimo. Listo para confirmar.'}
        </p>}
    </Paso>;
}